<div class="bg-white px-4 pb-4">
    <div class="flex h-16 items-center">
        <button
            class="ml-1 h-4 w-4 cursor-pointer"
            (click)="navigateBack()"
            attr.aria-label="{{ 'LOCAL_BTN_BACK' | translate }}">
            <mat-icon class="dark:filter-yellow" svgIcon="back-arrow"></mat-icon>
        </button>
        <div class="grow text-center text-base font-semibold text-black">
            {{ 'ADDITIONAL_INFO' | translate }}
        </div>
    </div>

    <div class="content">
        <div class="text-xxs font-medium text-[#414141]">{{ 'CARRIER_ORGANISATION' | translate }}</div>
        <div class="separator h-px border-b border-solid border-[#e6e6e6]"></div>
        <div class="mb-2 text-base">{{ (route$ | async)?.agency?.name }}</div>

        <div class="text-xxs font-medium text-[#414141]">{{ 'CONTACT_PHONE' | translate }}</div>
        <div class="text-base">{{ (route$ | async)?.agency?.phone }}</div>
        <div class="separator mb-2 h-px border-b border-solid border-[#e6e6e6]"></div>

        <div class="mb-2 cursor-pointer text-lg font-semibold text-primary" *ngIf="!!(route$ | async)?.agency?.fareURL">
            {{ 'TICKET_INFO_WEBSITE' | translate }}
            <span class="icon icon-arrow-right"></span>
        </div>
        <div
            class="separator mb-2 h-px border-b border-solid border-[#e6e6e6]"
            *ngIf="!!(route$ | async)?.agency?.fareURL && (route$ | async)?.desc"></div>

        <div class="text-xxs font-medium text-[#414141]" *ngIf="(route$ | async)?.desc">
            {{ 'ADDITIONAL_ROUTE_INFORMATION' | translate }}
        </div>

        <div class="text-base" *ngIf="(route$ | async)?.desc">
            <div innerHTML="{{ (route$ | async).desc }}"></div>
        </div>
    </div>
</div>
